export default {
  data() {
    return {
      token: "",
      complete: false,
      failed: false,
      loading: true,
    };
  },
  methods: {
    verify() {},
  },
  mounted() {
    this.token = this.$route.query.token;
    this.verify();
  },
};
